import { useState, useCallback } from 'react'

export function useToast () {
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success',
    icon: null,
    customColor: null
  })

  const showToast = useCallback((message, severity = 'success', icon = null, customColor = null) => {
    setToast({ open: true, message, severity, icon, customColor })
  }, [])

  const closeToast = useCallback(() => {
    setToast(prev => ({ ...prev, open: false }))
  }, [])

  return { toast, showToast, closeToast }
}

export default useToast
